// extracted by mini-css-extract-plugin
export var black = "_2r-6";
export var brand = "_2r-1";
export var ddefault = "_2r-0";
export var error = "_2r-3";
export var gray = "_2r-2";
export var highContrast = "_2r-8";
export var outline = "_2r-7";
export var success = "_2r-5";
export var warning = "_2r-4";